import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Typography, Button, Grid, Box, Container } from "@material-ui/core";
import { ArrowBack, Add as AddIcon } from "@material-ui/icons";
import AdminSuppliersList from "./AdminSupplierslist";

/**
 * AvailableSuppliers component renders a page with a list of all suppliers
 * available in the app. It also provides a button to add a new supplier.
 *
 * @component
 * @returns {React.Element} The rendered component.
 */
export default function AvailableSuppliers() {
  const history = useHistory();

  return (
    <div>
      <Container>
        <Box mb={3}>
          <Button
            color="primary"
            startIcon={<ArrowBack />}
            onClick={() => history.goBack()}
          >
            Back
          </Button>
        </Box>

        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          style={{ marginBottom: 24 }}
        >
          <Grid item>
            <Typography variant="h4" style={{ fontWeight: "bold" }}>
              Suppliers
            </Typography>
          </Grid>
          <Grid item>
            <Link to="/addSupplier" style={{ textDecoration: "none" }}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                style={{ borderRadius: 8 }}
              >
                Add Supplier
              </Button>
            </Link>
          </Grid>
        </Grid>
        <AdminSuppliersList />
      </Container>
    </div>
  );
}
